import st from './Button.module.scss'
import {Link} from 'react-router-dom';

export const Button = ({ text, cn, onClick, variant, type, to })=> {
    const className = `${st.button} ${cn || ''} ${st[variant] || ''}`.trim()

    if (type === 'link') {
        return (
            <Link to={to} className={className}>
                {text}
            </Link>
        )
    }

    return (
        <button className={className} onClick={onClick}>
            {text}
        </button>
    )
}
